import React, { useState } from "react";
import "./DownloadForm.css";

const DownloadForm = ({ onClose, courseName, pdfUrl }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    education: "",
    description: "",
  });

  const [errors, setErrors] = useState({
    email: "",
    phone: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

    // Clear error message when user types
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const validatePhone = (phone) => {
    return /^\d{10}$/.test(phone);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!validateEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (!validatePhone(formData.phone)) {
      newErrors.phone = "Please enter a valid 10-digit phone number.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const response = await fetch("/api/course-download", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          courseName,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        console.log("✅ Form submitted successfully:", result);
        // Download the PDF
        window.open(pdfUrl, "_blank");
        // Close form
        onClose();
      } else {
        console.error("❌ Form submission failed:", result.message);
        alert("Failed to submit form. Please try again.");
      }
    } catch (error) {
      console.error("❌ Network or server error:", error);
      alert("Server error. Please try again later.");
    }
  };

  return (
    <div className="form-overlay" noValidate>
      <div className="form-container">
        <h2>{courseName} - Download PDF</h2>

        <form onSubmit={handleSubmit} noValidate>
          <div className="form-grid">
            <input
              name="name"
              placeholder="Name"
              required
              onChange={handleChange}
            />

           <div>
  <input
    name="email"
    type="text" // not type="email" so we can control validation ourselves
    placeholder="Email"
    required
    value={formData.email}
    onChange={(e) => {
      const value = e.target.value;
      setFormData((prev) => ({ ...prev, email: value }));

      // Email regex validation
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value.trim() === "") {
        setErrors((prev) => ({ ...prev, email: "Email is required" }));
      } else if (!emailPattern.test(value)) {
        setErrors((prev) => ({ ...prev, email: "Please enter a valid email address" }));
      } else {
        setErrors((prev) => ({ ...prev, email: "" }));
      }
    }}
  />
  {errors.email && <p className="error-text">{errors.email}</p>}
</div>


            <div>
              <input
                name="phone"
                placeholder="Phone Number"
                required
                onChange={handleChange}
              />
              {errors.phone && <p className="error-text">{errors.phone}</p>}
            </div>

            <input
              name="education"
              placeholder="Education"
              required
              onChange={handleChange}
            />
            <textarea
              name="description"
              placeholder="Description"
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="form-buttons">
            <button type="submit">Submit & Download</button>
            <button type="button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DownloadForm;
